import * as CookieConsent from 'vanilla-cookieconsent';
import { getConfig } from './config';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

const CONSENT_ENDPOINT = "https://labelwiseappservices.azurewebsites.net/api/cookie";

/**
 * This event is triggered only the very first time that the user expresses their choice of consent (accept/reject).
 */
function doFirstConsent() {
    console.log("# First consent");

    logConsent();
}
/**
 * This event is triggered the very first time the user expresses their choice of consent — just like onFirstConsent —
 * but also on every subsequent page load.
 */
function doConsent() {
    console.log("# Consent");

    updateConsent();
}
/**
 * This event is triggered when the user modifies their preferences and only if consent has already been provided.
 */
function doConsentChange() {
    console.log("# Consent change");

    updateConsent();
    logConsent();
}

/**
 * Updated Consent Mode and sends an event to the datalayer
 * Usefull for Tag Manager tags who need specific consent before they can trigger
 */
function updateConsent() {
    let consent = {
        'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
        'ad_storage': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_user_data': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
        'ad_personalization': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
    };

    window.gtag?.('consent', 'update', consent);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'consentUpdateEvent',
        consentUpdateState: consent
    });
}

/**
 * Logs users consent in an external database for future reference
 */
function logConsent() {
    const cookie = CookieConsent.getCookie();
    const userConsent = {
        "cid": cookie.consentId,
        "categories": {
            "necessary": true,
            "analytics": CookieConsent.acceptedCategory('analytics'),
            "marketing": CookieConsent.acceptedCategory('marketing')
        },
        "changedAt": cookie.lastConsentTimestamp,
        "site": window.location.hostname,
    }

    fetch(CONSENT_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userConsent)
    })

    console.log(userConsent)
}


export function initCookieConsent(lang = 'nl') {
    const config = getConfig(lang)

    CookieConsent.run({
        ...config,
        onFirstConsent: () => {
            doFirstConsent()
        },
        onConsent: () => {
            doConsent()
        },
        onChange: () => {
            doConsentChange()
        }
    });
}

window.initCookieConsent = initCookieConsent;
window.CookieConsent = CookieConsent;
